import { Entity } from '@decahedron/entity';

export default class Message extends Entity {
  public id: string = null;

  public name: string = null;

  public email: string = null;

  public phone: string = null;

  public message: string = null;

  public url: string = null;

  public sent: string = null;

  get messageBrs() {
    return this.message.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
}
